import GetAppIcon from '@mui/icons-material/GetApp';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import Flex from 'ui/Flex/Flex';

type DownloadConfig = {
    onDownload: () => void;
    isLoading: boolean;
};
type Props = {
    title?: string;
    subtitle?: string;
    description?: string;
    downloadConfig?: DownloadConfig;
};

const ModalHeader = ({
    title,
    subtitle,
    description,
    downloadConfig,
}: Props) => (
    <Box>
        {title && (
            <Typography variant="h4" color="primary">
                {title}
            </Typography>
        )}
        <Flex alignItems="flex-start" justifyContent="space-between" gap="1rem">
            <Box sx={{ flex: 1 }}>
                {subtitle && (
                    <Typography variant="h5" sx={{ mb: '0.8rem', mt: '2rem' }}>
                        {subtitle}
                    </Typography>
                )}
                {description && (
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '12px',
                            mb: '1rem',
                            color: 'rgba(0, 0, 0, 0.6)',
                        }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>
            {downloadConfig && (
                <IconButton
                    onClick={downloadConfig.onDownload}
                    color="primary"
                    sx={{ mt: subtitle ? '2rem' : 0 }}
                    disabled={downloadConfig.isLoading}
                >
                    <GetAppIcon />
                </IconButton>
            )}
        </Flex>
    </Box>
);

export default ModalHeader;
